import { ROLES } from './roles';

/**
 * Definición de permisos del sistema
 * Cada permiso define qué roles pueden realizarlo
 */
export const PERMISSIONS = {
  // === GESTIÓN DE USUARIOS ===
  MANAGE_USERS: {
    roles: [ROLES.ADMINISTRADOR],
    description: 'Crear, editar y eliminar usuarios'
  },
  
  CHANGE_USER_PASSWORD: {
    roles: [ROLES.ADMINISTRADOR],
    description: 'Cambiar contraseñas de usuarios'
  },

  // === GESTIÓN DE EMPLEADOS ===
  MANAGE_EMPLOYEES: {
    roles: [ROLES.ADMINISTRADOR, ROLES.ADMINISTRATIVO, ROLES.COORDINADOR],
    description: 'Gestionar información de empleados'
  },

  VIEW_EMPLOYEES: {
    roles: [ROLES.ADMINISTRADOR, ROLES.ADMINISTRATIVO, ROLES.AUDITOR, ROLES.COORDINADOR],
    description: 'Ver información de empleados'
  },

  // === GESTIÓN DE NOVEDADES ===
  CREATE_NOVEDADES: {
    roles: [ROLES.ADMINISTRADOR, ROLES.ADMINISTRATIVO, ROLES.COORDINADOR],
    description: 'Crear nuevas novedades'
  },

  EDIT_NOVEDADES: {
    roles: [ROLES.ADMINISTRADOR, ROLES.ADMINISTRATIVO, ROLES.COORDINADOR],
    description: 'Editar novedades existentes'
  },

  DELETE_NOVEDADES: {
    roles: [ROLES.ADMINISTRADOR, ROLES.ADMINISTRATIVO, ROLES.COORDINADOR],
    description: 'Eliminar novedades'
  },

  VIEW_NOVEDADES: {
    roles: [ROLES.ADMINISTRADOR, ROLES.ADMINISTRATIVO, ROLES.AUDITOR, ROLES.COORDINADOR],
    description: 'Ver novedades'
  },

  // === GESTIÓN DE CATÁLOGOS ===
  MANAGE_CAMPUS: {
    roles: [ROLES.ADMINISTRADOR],
    description: 'Gestionar campus'
  },

  MANAGE_DEPENDENCIAS: {
    roles: [ROLES.ADMINISTRADOR],
    description: 'Gestionar dependencias'
  },

  MANAGE_TIPOS_CONTRATOS: {
    roles: [ROLES.ADMINISTRADOR],
    description: 'Gestionar tipos de contratos'
  },

  MANAGE_TIPOS_NOVEDADES: {
    roles: [ROLES.ADMINISTRADOR],
    description: 'Gestionar tipos de novedades'
  },

  // === OPERACIONES GENERALES ===
  UPLOAD_FILES: {
    roles: [ROLES.ADMINISTRADOR, ROLES.ADMINISTRATIVO, ROLES.COORDINADOR],
    description: 'Subir archivos al sistema'
  },

  EXPORT_DATA: {
    roles: [ROLES.ADMINISTRADOR, ROLES.ADMINISTRATIVO, ROLES.AUDITOR, ROLES.COORDINADOR],
    description: 'Exportar datos del sistema'
  },

  // === AUDITORÍA ===
  VIEW_AUDIT_LOGS: {
    roles: [ROLES.ADMINISTRADOR, ROLES.AUDITOR],
    description: 'Ver logs de auditoría'
  }
};

/**
 * Agrupa permisos por categorías para mejor organización
 */
export const PERMISSION_CATEGORIES = {
  USUARIOS: [
    'MANAGE_USERS',
    'CHANGE_USER_PASSWORD'
  ],
  
  EMPLEADOS: [
    'MANAGE_EMPLOYEES',
    'VIEW_EMPLOYEES'
  ],
  
  NOVEDADES: [
    'CREATE_NOVEDADES',
    'EDIT_NOVEDADES',
    'DELETE_NOVEDADES',
    'VIEW_NOVEDADES'
  ],
  
  CATALOGOS: [
    'MANAGE_CAMPUS',
    'MANAGE_DEPENDENCIAS',
    'MANAGE_TIPOS_CONTRATOS',
    'MANAGE_TIPOS_NOVEDADES'
  ],
  
  GENERAL: [
    'UPLOAD_FILES',
    'EXPORT_DATA',
    'VIEW_AUDIT_LOGS'
  ]
};

export default PERMISSIONS;
